var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDevicesConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.212,
    height: 99.899,
    viewBox: "0 0 167.212 99.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_40761",
    x: 0,
    y: 16.587,
    width: 50.908,
    height: 50.928,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_40762",
    x: 111.539,
    y: 0,
    width: 55.673,
    height: 55.695,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_40760",
    x: 35.408,
    y: 1.984,
    width: 97.949,
    height: 97.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14327",
    "data-name": "Group 14327",
    transform: "translate(-285.092 6528.471)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 285.09, -6528.47)",
    filter: "url(#Path_40761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40761-2",
    "data-name": "Path 40761",
    d: "M17.574,20.769H3.2a3.194,3.194,0,0,1-3.2-3.2V3.2A3.194,3.194,0,0,1,3.2,0H17.574a3.194,3.194,0,0,1,3.2,3.2V17.574a3.194,3.194,0,0,1-3.2,3.2m30.334-3.2V3.2a3.194,3.194,0,0,0-3.2-3.2H30.334a3.2,3.2,0,0,0-3.2,3.2V17.574a3.2,3.2,0,0,0,3.2,3.2H44.713a3.194,3.194,0,0,0,3.2-3.2m0,27.159V30.355a3.194,3.194,0,0,0-3.2-3.2H30.334a3.2,3.2,0,0,0-3.2,3.2V44.733a3.2,3.2,0,0,0,3.2,3.2H44.713a3.194,3.194,0,0,0,3.2-3.2m-27.139,0V30.355a3.194,3.194,0,0,0-3.2-3.2H3.2a3.194,3.194,0,0,0-3.2,3.2V44.733a3.194,3.194,0,0,0,3.2,3.2H17.574a3.194,3.194,0,0,0,3.2-3.2",
    transform: "translate(1.5 17.09)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 285.09, -6528.47)",
    filter: "url(#Path_40762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40762-2",
    "data-name": "Path 40762",
    d: "M19.322,22.835H3.513A3.512,3.512,0,0,1,0,19.322V3.513A3.512,3.512,0,0,1,3.513,0H19.322a3.512,3.512,0,0,1,3.513,3.513V19.322a3.512,3.512,0,0,1-3.513,3.513m33.351-3.513V3.513A3.512,3.512,0,0,0,49.16,0H33.351a3.513,3.513,0,0,0-3.513,3.513V19.322a3.513,3.513,0,0,0,3.513,3.513H49.16a3.512,3.512,0,0,0,3.513-3.513m0,29.861V33.374a3.512,3.512,0,0,0-3.513-3.513H33.351a3.513,3.513,0,0,0-3.513,3.513V49.182A3.513,3.513,0,0,0,33.351,52.7H49.16a3.512,3.512,0,0,0,3.513-3.513m-29.838,0V33.374a3.512,3.512,0,0,0-3.513-3.513H3.513A3.512,3.512,0,0,0,0,33.374V49.182A3.512,3.512,0,0,0,3.513,52.7H19.322a3.512,3.512,0,0,0,3.513-3.513",
    transform: "translate(113.04 0.5)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 285.09, -6528.47)",
    filter: "url(#Path_40760)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40760-2",
    "data-name": "Path 40760",
    d: "M29.315,34.645H5.33A5.328,5.328,0,0,1,0,29.315V5.33A5.328,5.328,0,0,1,5.33,0H29.315a5.328,5.328,0,0,1,5.33,5.33V29.315a5.328,5.328,0,0,1-5.33,5.33m50.6-5.33V5.33A5.328,5.328,0,0,0,74.585,0H50.6a5.33,5.33,0,0,0-5.33,5.33V29.315a5.33,5.33,0,0,0,5.33,5.33H74.585a5.328,5.328,0,0,0,5.33-5.33m0,45.3V50.635a5.328,5.328,0,0,0-5.33-5.33H50.6a5.33,5.33,0,0,0-5.33,5.33V74.619a5.33,5.33,0,0,0,5.33,5.33H74.585a5.328,5.328,0,0,0,5.33-5.33m-45.27,0V50.635a5.328,5.328,0,0,0-5.33-5.33H5.33A5.328,5.328,0,0,0,0,50.635V74.619a5.328,5.328,0,0,0,5.33,5.33H29.315a5.328,5.328,0,0,0,5.33-5.33",
    transform: "translate(124.36 7.98) rotate(90)",
    fill: "#56aa1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDevicesConfirmation);
export default __webpack_public_path__ + "static/media/remove_devices_confirmation.ecd55f9aa04c8367de7231dbc02f2dc3.svg";
export { ForwardRef as ReactComponent };